import React from 'react';
import styles from './keyWord.module.css';
import { Link } from 'react-router-dom';

export default ({ keyWords }: { keyWords: string[] }) => {
  function linkText(a: string) {
    if (a === '免费') {
      return `/shudanDetails?type=freebook`;
    }
    if (a === '推荐') {
      return `/shudanDetails?type=editorRecommendation`;
    }
    if (a === '专题') {
      return `/subjectList`;
    }
    if (a === '包月') {
      return `/monthlyZone`;
    }
    if (a === '男频') {
      return `/shudanDetails?type=boysFavorite`;
    }
    if (a === '女频') {
      return `/shudanDetails?type=girlsFavorite`;
    }
    if (a === '完结') {
      return `/shudanDetails?type=finishedWork`;
    }
    if (a === '书单') {
      return `/booklist`;
    }
    return '';
  }
  return (
    <div className={styles.keyWord}>
      {keyWords.map((item, index) => {
        return (
          <Link to={linkText(item)} className={styles.keyWordItem} key={index}>
            <div className={styles.keyWordIcon}></div>
            {item}
          </Link>
        );
      })}
    </div>
  );
};
